const validate = (values) => {
  const errors = {};

  if (!values.type || values.type.trim() === '') {
    errors.type = 'Please enter type';
  }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/validate.js